import { Form } from "antd";
import React from "react";
import { InputNumberStd } from "src/components/InputNumberStd";
import { AttrTypeName } from "src/types/AttrType";
import styles from "../EditorInfo2.module.less";
import { edCompField } from "../ParamsEditorInfo2";
import { Addon, Precision } from "./common";

interface Props {
  typeName: string;
}

export const InputNumberEdProps: React.FC<Props> = ({ typeName }) => (
  <>
    <div className={styles.twoCols}>
      <Form.Item name={edCompField("min")} label="Минимальное значение">
        <InputNumberStd />
      </Form.Item>
      <Form.Item name={edCompField("max")} label="Максимальное значение">
        <InputNumberStd />
      </Form.Item>
    </div>
    {typeName === AttrTypeName.number && <Precision />}
    <Addon />
  </>
);
